// internal imports
import Service from 'core/decorators/Service';
import ConfigUtil from 'core/util/config/ConfigUtil';
import TokenSession from 'core/util/session/TokenSession';
import StringUtil from 'core/util/StringUtil';
import IResolverService, { CachingPolicy, QueryFunction } from '../IResolverService';

/**
 * @overview: An {@link IQueryResolver} using {@link XMLHttpRequest}
 * @author: jesposito
 */

@Service()
export default class XHRResolverService extends IResolverService {
	private static NAME: string = "xhr";

	private headers: {[key: string]: string};
	private uri: string; // service uri

	constructor() {
		super();

		// get the authentication token from local storage if it exists
		const token = TokenSession.getToken();

		this.headers = {
			'Authorization': `Bearer ${token}`,
			'Content-Type': 'application/json'
		};

		this.uri = ConfigUtil.getEnvConfig().graphqlUri;
	}

	public execute(query: string | QueryFunction, params?: object): Promise<any> {

		// if the query is a function then pass the params in
		const q = typeof query === "string" ? query : query(params);

		const xhr = new XMLHttpRequest();

		const result = new Promise((resolve, reject) => {

			xhr.onreadystatechange = function() {
				if (xhr.readyState === 4) {

					if (xhr.status === 200) {
						resolve(xhr.responseText);
					} else {
						reject(xhr.responseText);
					}
				}
			};

		});

		xhr.open("POST", this.uri, true); // true for asynchronous

		Object.entries(this.headers).map( (h) => (
			xhr.setRequestHeader(h[0], h[1])
		));

		const body = JSON.stringify({ query: q });

		xhr.send(body);

		// return the promise
		return XHRResolverService.validateResponse(result);
	}

	public getServiceId(): string {
		return XHRResolverService.NAME;
	}

	/*public getConditions() {
		return {fetchPolicy: CachingPolicy.NONE};
	}*/

	public clearCache() {
		return Promise.resolve();
	}
}




// WEBPACK FOOTER //
// ./src/core/service/resolver/impl/XHRResolver.service.ts